/**
 * Runtime mode detection utility.
 * Returns the current Vite mode (localhost, development, qa, uat, production) from import.meta.env.MODE.
 */
export const getRuntimeMode = (): string => import.meta.env.MODE;
